import LoadingScreen from 'components/LoadingScreen';
import AuthGuard from 'guard/AuthGuard';
import GuestGuard from 'guard/GuestGuard';
import AuthLayout from 'layouts/AuthLayout';
import DashboardLayout from 'layouts/DashboardLayout';
import OnboardingLayout from 'layouts/OnboardingLayout';
import Page403 from 'pages/Page403';
import { ElementType, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import lazyWithRetry from './../lazyWithRetry';

const Loadable = (Component: ElementType) => (props: any) => {
  return (
    <Suspense fallback={<LoadingScreen isDashboard={true} />}>
      <Component {...props} />
    </Suspense>
  );
};

const Profile = Loadable(lazyWithRetry(() => import('pages/accounts/accounts')));
const Onboarding = Loadable(lazyWithRetry(() => import('pages/onboarding')));
const Page404 = Loadable(lazyWithRetry(() => import('pages/Page404')));
const CustomerPageContainer = Loadable(
  lazyWithRetry(() => import('pages/customer_page/CustomerPageContainer'))
);
const PaymentGateways = Loadable(lazyWithRetry(() => import('pages/payment_gateways')));
const Payments = Loadable(lazyWithRetry(() => import('pages/payments')));
const EmailPageContainer = Loadable(
  lazyWithRetry(() => import('../pages/email_send_page/skeleton/EmailPageContainer'))
);

const CreateManualPurchaseOrder = Loadable(
  lazyWithRetry(() => import('pages/ManualDocumentV2/forms/AR/purchaseOrder'))
);


const Router = () => {
  const customerId = localStorage.getItem('customerId');
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path=""
          element={
            <GuestGuard>
              <AuthLayout />
            </GuestGuard>
          }
        >
          <Route path="/" element={<EmailPageContainer />} />

          <Route path="/:id" element={<EmailPageContainer />} />
        </Route>

        <Route
          path=""
          element={
            <AuthGuard>
              <OnboardingLayout />
            </AuthGuard>
          }
        >
          <Route path="/:id/onboarding" element={<Onboarding />} />
        </Route>
        <Route
          path=""
          element={
            <AuthGuard>
              <DashboardLayout />
            </AuthGuard>
          }
        >
          <Route
            path="/:id/documents/create-purchase-order"
            element={<CreateManualPurchaseOrder />}
          />
          <Route path="/:id/documents" element={<CustomerPageContainer />} />
          <Route path="/:id/account" element={<Profile />} />
          <Route path="/:id/payments/paymentgateways" element={<PaymentGateways />} />
          <Route path="/:id/payments/invoicepayments" element={<Payments />} />
        </Route>

        <Route path="/:id/404" element={<Page404 />} />
        <Route path="/404" element={<Page404 />} />
        <Route path="/:id/403" element={<Page403 />} />
        <Route path="/403" element={<Page403 />} />
        <Route
          path="*"
          element={<Navigate to={customerId ? `${customerId}/404` : '/404'} replace />}
        />
      </Routes>
    </BrowserRouter>
  );
};
export default Router;
